/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-empty-function */
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  forwardRef
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { TooltipOptions } from 'primeng/api';

export interface MButtonGroupOption {
  label: string;
  value?: string;
  disabled?: boolean;
  perOptionCount?: number;
  tooltip?: string;
  tooltipOptions?: TooltipOptions;
}

@Component({
  selector: 'm-button-group',
  templateUrl: './m-button-group.component.html',
  styleUrls: ['./m-button-group.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MButtonGroupComponent),
      multi: true
    }
  ]
})
export class MButtonGroupComponent implements OnInit, ControlValueAccessor {
  @Input() options!: MButtonGroupOption[];
  @Input() selectedOption = '';
  @Input() showOptionCount = true;
  @Input() disabled = false;
  @Output() selectedOptionChange = new EventEmitter<string>();

  // Callbacks for ControlValueAccessor.
  private onChange: (value: any) => void = () => {};
  private onTouched: () => void = () => {};

  ngOnInit(): void {
    // If no selected option is provided and there is at least one option, default to the first one.
    if (!this.selectedOption && this.options.length > 0) {
      this.selectedOption = this?.options[0]?.value as string;
      this.propagateChange();
    }
  }

  onButtonClickHandler(index: number): void {
    const option = this.options[index];

    if (!option) return;
    if (this.disabled || option.disabled) return;

    this.selectedOption = option.value as string;
    this.propagateChange();
    this.selectedOptionChange.emit(this.selectedOption);
  }

  propagateChange(): void {
    this.onChange(this.selectedOption);
    this.onTouched();
  }

  // ControlValueAccessor methods.
  writeValue(value: any): void {
    if (value !== undefined) {
      this.selectedOption = value;
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
}
